import {utilHelper} from "../../_helpers";

const relativeUrl = 'api/lang'

export const langService = {
    search,
    getItem,
    saveItem,
    updateItem,
    deleteItem,
    getAll,
    translateApp
};

// function getAll() {
//     const dataRequest = {
//         item: {
//             enabledToEdit : true
//         }
//     }
//     return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${1000}&offset=${0}`, 'POST', { data: dataRequest, showAlert: false })
// }
function getAll() {
    return utilHelper.doRequest(`${relativeUrl}/getAll`, 'GET')
}

function search(offset, max, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data, showAlert: false })
}

function getItem(id) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'GET', { showAlert: false })
}

function saveItem(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', {data});
}

function updateItem(id, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'PUT', {data});
}

function deleteItem(id, db) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}/${db}`, 'DELETE', { })
}

function translateApp(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/translateApp`, 'POST', {data});
}